module.exports = __webpack_public_path__ + "img/L_6S.2e5cfb81.png";